import { createRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { Alert, AlertDescription, MutedText } from '@volee/ui'

import { ME_KEY } from '../auth/me.ts'
import { messages } from '../messages/index.ts'
import { auth } from '../services/auth.ts'
import { rootRoute } from './root.tsx'

// The OAuth callback route, and it deliberately does not validate its search params
// (apps/frontend/docs/razionale-che-il-codice-indica.md).
export const callbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/callback',
  staticData: { chrome: 'bare' },
  component: Callback,
})

function Callback() {
  const navigate = callbackRoute.useNavigate()
  const { queryClient } = callbackRoute.useRouteContext()
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false

    async function complete() {
      try {
        const { returnTo } = await auth.completeLogin(window.location.href)
        if (cancelled) return
        // The session changed: `['me']` has to be refetched, not reused from a previous
        // user's cache.
        await queryClient.invalidateQueries({ queryKey: ME_KEY })
        await navigate({ to: returnTo, replace: true })
      } catch (error) {
        // AuthError carries an English `message` for developers: not shown, but logged —
        // a swallowed error here once cost a whole debugging round (StrictMode replay).
        console.error('completeLogin failed', error)
        if (!cancelled) setFailed(true)
      }
    }

    void complete()
    return () => {
      cancelled = true
    }
  }, [navigate, queryClient])

  if (failed) {
    return (
      <Alert variant="destructive">
        <AlertDescription>{messages.signIn.failed}</AlertDescription>
      </Alert>
    )
  }

  return <MutedText>{messages.signIn.pending}</MutedText>
}
